import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Router, Switch, Route, } from 'react-router'
import createHistory from 'history/createBrowserHistory'

import categories from '../../client/assets/categories'

import '../public/index.css'
import Navigation from './components/Navigation'
import Home from './components/Home'
import Contact from './components/Contact'
import Cookies from './components/Cookies'
import Category from './components/Category'
import NotFound from './components/NotFound'

const history = createHistory()

class ATCGardens extends Component {

  constructor(props) {
    super(props)

    this.state = {
      categories: categories
    }

    this.routes = this.routes.bind(this)
  }

  routes() {
    return Object.keys(this.state.categories).map(cat => (
      Object.keys(this.state.categories[cat]).map((subCat, key) => <Route 
          exact path={this.state.categories[cat][subCat].url} 
          key={key}
          render={() => <Category assets={this.state.categories[cat][subCat]} cat={subCat}/>} 
          />
        )
      )
    )
  }

  render() {
    return (
      <div className='app'>
        <div className='app-header'>
          <Navigation />
        </div>
          <Router history={history}>
              <div className='app-body'>
                <Switch>
                  <Route exact path='/' render={() => <Home categories={this.state.categories}/>} />
                  <Route exact path='/contact' render={() => <Contact/>} />
                  <Route exact path='/cookies' render={() => <Cookies/>} />
                  {this.routes()}
                  <Route path='*' component={NotFound} />
                </Switch>
              </div>
          </Router>
      </div>
    )
  }
 
}

if (process.env.NODE_ENV !== 'production') {
  console.log('Looks like we are in development mode!')
}

ReactDOM.render(<ATCGardens />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js